import React, { useEffect, useState } from "react";
import * as home from "../components/home";
import MainHome from "../components/carousel/MainHome";
import { useDispatch, useSelector } from "react-redux";
import { fetchCart } from "../redux/actions/cartActions";
import axios from "axios";
import { getBanners } from "../Services/MainServices";

const Home = () => {
  const [banners, setBanners] = useState();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  useEffect(() => {
    getBanner();
  }, []);

  const getBanner = async () => {
    try {
      const response = await getBanners();
      if (response.status === 200 || response?.data?.status === "success") {
        setBanners(response?.data?.data ?? {});
      }
    } catch (error) {}
  };

  return (
    <div className="mt-3 md:mt-5 flex flex-col gap-5">
      <MainHome />
      <home.ShopCardsSection banners={banners?.banners} />
      <home.HeroBar />
      <home.PopularProducts />
      <home.ProductBanner topBanners={banners?.top_banners} />
      {/* <home.GreatSavingsSection /> */}
      {isAuthenticated && user && <home.BlockbusterDeals />}
      {/* <home.Shortlist /> */}
    </div>
  );
};

export default Home;
